import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatChipsModule } from '@angular/material/chips';
import { RouterModule } from '@angular/router';

import { AvatarModule } from '@libs/src/avatar/avatar.module';
import { AccountFullNamePipeModule } from '@main-client/src/app/pipes/account-full-name-pipe/account-full-name-pipe.module';
import { DisplayUserPronounsPipeModule } from '@main-client/src/app/pipes/display-user-pronouns-pipe/display-user-pronouns.pipe.module';

import { ConnectionSummaryAccountInfoComponent } from './connection-summary-account-info.component';

@NgModule({
  declarations: [ConnectionSummaryAccountInfoComponent],
  imports: [
    AccountFullNamePipeModule,
    AvatarModule,
    CommonModule,
    DisplayUserPronounsPipeModule,
    FlexLayoutModule,
    MatChipsModule,
    RouterModule,
  ],
  exports: [ConnectionSummaryAccountInfoComponent],
})
export class ConnectionSummaryAccountInfoModule {}
